import { ReactElement } from 'react';

import DetailsCard from 'components/DetailsCard';
import BroadsignFramesRow from 'features/EntityDetails/components/BroadsignFramesRow';
import EntityDetail from 'features/EntityDetails/components/EntityDetails/EntityDetail';
import useStyles from 'features/EntityDetails/components/EntityDetails/EntityDetails.styles';
import {
  TDraftFrameOrLinkedAsset,
  isFrame,
  TLiveFrameOrLinkedAsset,
} from 'types/detailsEntityType';

type DeviceCardProps = {
  entity: TDraftFrameOrLinkedAsset | TLiveFrameOrLinkedAsset;
  previousEntity?: TLiveFrameOrLinkedAsset;
};

const DeviceCard = ({ entity, previousEntity }: DeviceCardProps) => {
  const classes = useStyles();
  const { nativeResolution, consolidatedResolutions, height, width } = entity;

  const detailsFirstRow: ReactElement = (
    <div className={classes.dataRow}>
      <EntityDetail
        label="Native Resolution"
        value={nativeResolution}
        previousValue={previousEntity?.nativeResolution}
        layout="stacked"
      />
      <EntityDetail
        label="Consolidated Resolution"
        multiValue={consolidatedResolutions}
        previousMultiValue={previousEntity?.consolidatedResolutions}
        layout="stacked"
      />
      <EntityDetail
        label="Height"
        value={height}
        previousValue={previousEntity?.height}
        layout="stacked"
      />
      <EntityDetail
        label="Width"
        value={width}
        previousValue={previousEntity?.width}
        layout="stacked"
      />
    </div>
  );

  return (
    <DetailsCard
      title="DEVICE DETAILS"
      detailsRows={
        isFrame(entity)
          ? [
              detailsFirstRow,
              <BroadsignFramesRow
                broadsignFrames={entity.broadsignFrames}
                previousBroadsignFrames={
                  previousEntity && isFrame(previousEntity)
                    ? previousEntity.broadsignFrames
                    : undefined
                }
              />,
            ]
          : [detailsFirstRow]
      }
    />
  );
};

export default DeviceCard;
